import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {Bot} from "../../../../../../models/bot";
import { BotDeterminant } from "../../../../../../models/bot-determinant";
import { DeterminantControllerService } from "../../../../../../services/registration-controller/determinant-controller.service";
import {BotControllerService} from "../../../../../../services/role-controller/bot-controller.service";
import {RoleControllerService} from "../../../../../../services/role-controller/role-controller.service";
import {Store} from "../../../../../../services/store.service";
import {BaseError} from "../../../../base-error";
import * as _ from "lodash";

@Component({
  selector: "bot-determinant",
  templateUrl: "./bot-determinant.component.html",
  providers: [DeterminantControllerService, RoleControllerService, BotControllerService],
})
export class BotDeterminantComponent extends BaseError implements OnChanges, OnInit {

  @Input() public determinant: BotDeterminant;
  @Output() public determinantChangedEvent = new EventEmitter();
  @Input() public stickyScrolling: boolean = false;
  public bots: Bot[] = [];
  public botList: Bot[] = [];

  constructor(private botService: BotControllerService,
              public toastr: ToastrService,
              public store: Store, private route: ActivatedRoute) {
    super(toastr);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      if (params.serviceId) {
        this.store.state.common.serviceId = params.serviceId;
        if (!this.determinant) {
          this.determinant = new BotDeterminant();
          this.determinant.serviceId = this.store.state.common.serviceId;
        }
        // if (!this.determinant.botRoles) { this.determinant.botRoles = []; }
        if (!this.determinant.bots) { this.determinant.bots = []; }
        if (!this.determinant.serviceId) {
          this.determinant.serviceId = this.store.state.common.serviceId;
          this.determinant.bot_service_id = this.store.state.common.serviceId;
        }
        this.loadBots();
      }
    });
  }

  private filterList() {
    let list;
    if (this.determinant && this.bots.length && this.determinant.bots.length) {
        list = this.bots.filter((bot) => {
            return this.determinant.bots.every((br) => {
              return br.id !== bot.id;
            });
        });
    } else {
      list = this.bots;
    }
    list = _.sortBy(list, [(d) => d.name.toLowerCase()], ["asc"]);
    this.botList = list.filter((b) => b.botType === "data")
        .concat(list.filter((b) => b.botType === "internal"))
        .concat(list.filter((b) => b.botType === "document"))
        .concat(list.filter((b) => b.botType === "message"))
        .concat(list.filter((b) => b.botType === "system"));
}

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes.determinant) {
      if (changes.determinant.currentValue) {
        this.determinant = changes.determinant.currentValue;
      }
    }
  }

  public updateBots(event: any) {
    if (event.bot && event.bot.id) {
      if (event.add) {
        const bt = this.bots.find((bot) => bot.id === event.bot.id);
        this.determinant.bots.push(bt);
      } else {
        const bti = this.determinant.bots.findIndex((bot) => bot.id === event.bot.id);
        this.determinant.bots.splice(bti, 1);
      }
      this.setBotService();
    }
  }

  public setBotService() {
    this.filterList();
    this.determinantChangedEvent.emit(this.determinant);
  }

  public loadBots() {
    if (this.store.state.common.serviceId) {
      this.botService.getServiceValidationBots(this.store.state.common.serviceId).subscribe(
          (data) => {
            this.bots = data;
            this.filterList();
          },
      );
    }
  }

}
